import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/centennial-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-centennial-colorado",
      statusCode: 301,
    });
  },
});
